var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 1.66602H15.8333C16.75 1.66602 17.5 2.41602 17.5 3.33268V15.9994C17.5 17.166 16.3333 17.9993 15.25 17.5827L13.9167 17.0827C13.5 16.916 13.0833 16.916 12.6667 17.166L10.6667 18.0827C10.25 18.2493 9.75 18.2493 9.33333 18.0827L7.33333 17.166C6.91667 16.9993 6.5 16.9993 6.08333 17.0827L4.75 17.4993C3.66667 17.916 2.5 17.0827 2.5 15.9994V3.33268C2.5 2.41602 3.25 1.66602 4.16667 1.66602ZM14.1667 6.49935C14.5 6.49935 14.8333 6.24935 14.8333 5.83268C14.8333 5.41602 14.5 5.16602 14.1667 5.16602H5.83333C5.5 5.16602 5.16667 5.49935 5.16667 5.83268C5.16667 6.16602 5.5 6.49935 5.83333 6.49935H14.1667ZM14.8333 9.16602C14.8333 9.49935 14.5833 9.83268 14.1667 9.83268H5.83333C5.5 9.83268 5.16667 9.58268 5.16667 9.16602C5.16667 8.74935 5.41667 8.49935 5.83333 8.49935H14.1667C14.5 8.49935 14.8333 8.83268 14.8333 9.16602ZM10 13.166C10.3333 13.166 10.6667 12.916 10.6667 12.4993C10.6667 12.0827 10.4167 11.8327 10 11.8327H5.83333C5.5 11.8327 5.16667 12.0827 5.16667 12.4993C5.16667 12.916 5.41667 13.166 5.83333 13.166H10Z",
    fill: "#1D4650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.031f7d9c37066317f6f22087a23f93b9.svg";
export { ForwardRef as ReactComponent };